import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  searchTextExecute: PropTypes.func.isRequired,
}

export default propTypes
